import React from 'react';
import { useNavigate } from 'react-router-dom';
import lock from '../../styles/images/lock.svg';
import ImageCard from '../common/ImageCard';

const FriendCard = React.forwardRef((props, ref) => {
  const navigate = useNavigate();

  // 适配V2 API格式
  const {
    id,
    fields = {},
  } = props;

  const title = fields.title || '';
  const body = fields.body_text || fields.body || '';
  const isPublic = fields.published !== false;
  const coverImage = fields.cover_image;
  const author = props.user || props.author || props.creator || {};

  return (
    <ImageCard
      ref={ref}
      title={title}
      description={body}
      coverImage={coverImage}
      author={author}
      likes={null}
      onClick={() => navigate(`/explore/friends/${id}`)}
      height="h-80"
      className="rounded-2xl border border-black"
      renderOverlay={() => !isPublic && (
        <img
          src={lock}
          alt="lock"
          className="absolute top-2 right-2 w-6 h-6 bg-white rounded"
        />
      )}
    />
  );
});

FriendCard.displayName = 'FriendCard';

export default FriendCard;
